import { useSelector } from 'react-redux';

const useRestaurants = () => {
  const { restaurants, pagination, users, restaurantAnalytics } = useSelector(
    (state) => state.restaurantSlice
  );

  return {
    restaurants,
    pagination,
    users,
    site_dashboard_data: restaurantAnalytics
  };
};

export default useRestaurants;
